import { Capacitor } from "@capacitor/core";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const formatter = new Intl.NumberFormat("en-US")

export function resolveImageUrl(src = "") {
  const isNative = Capacitor.isNativePlatform;
  if (isNative) {
    let url = "https://backend-new.billzpay.com.ng" + src.substring(6, src.length)
    return url;
  }
  return src
}